module.exports = __webpack_public_path__ + "img/ShopPandamochi.95fdcd50.png";